const THEATRE_CRITERIA_TYPES = {
  THEATRE_BY_ID: "theatreById",
  SCREEN_BY_ID: "screenById",
  THEATRE_TYPE: "theatreTypes",
  THEATRE_LOCATION_TYPES: "theatreLocationTypes",
  DIGITAL_INTEGRATORS: "digitalIntegrators",
  PROJECTION_TYPES: "projectionTypes",
  COOLING_TYPES: "coolingTypes",
  EXPERIENCES: "experiences",
  SEATING_CAPACITY: "seatingCapacity",
  TICKET_PRICE: "ticketPrice",
  PLAYLIST_TEMPLATE: "playlistTemplate",
  PLAYLIST_PACK: "playlistPack",
  SEGMENT_TYPE: "segmentType",
  AUDITORIUM_LENGTH: "auditoriumLength",
  AUDITORIUM_WIDTH: "auditoriumWidth",
  AUDITORIUM_HEIGHT: "auditoriumHeight",
  AUDITORIUM_DIMENSIONS: "auditoriumDimensions",
};

const THEATRE_CRITERIA_MENU_LIST = [
  {
    id: THEATRE_CRITERIA_TYPES.THEATRE_BY_ID,
    label: "Theatre By Id",
  },
  {
    id: THEATRE_CRITERIA_TYPES.SCREEN_BY_ID,
    label: "Screen By Id",
  },
  {
    id: THEATRE_CRITERIA_TYPES.THEATRE_TYPE,
    label: "Theatre Types",
  },
  {
    id: THEATRE_CRITERIA_TYPES.THEATRE_LOCATION_TYPES,
    label: "Theatre Location Types",
  },
  {
    id: THEATRE_CRITERIA_TYPES.DIGITAL_INTEGRATORS,
    label: "Digital Integrator",
  },
  {
    id: THEATRE_CRITERIA_TYPES.PROJECTION_TYPES,
    label: "Projection Types",
  },
  {
    id: THEATRE_CRITERIA_TYPES.COOLING_TYPES,
    label: "Cooling Types",
  },
  {
    id: THEATRE_CRITERIA_TYPES.EXPERIENCES,
    label: "Experiences",
  },
  {
    id: THEATRE_CRITERIA_TYPES.PLAYLIST_TEMPLATE,
    label: "Playlist Template",
  },
  {
    id: THEATRE_CRITERIA_TYPES.SEGMENT_TYPE,
    label: "Segment Type",
  },
  {
    id: THEATRE_CRITERIA_TYPES.PLAYLIST_PACK,
    label: "Playlist Pack",
  },
  {
    id: THEATRE_CRITERIA_TYPES.SEATING_CAPACITY,
    label: "Seating Capacity",
    minPlaceholder: "Minimum Capacity",
    maxPlaceholder: "Maximum Capacity",
  },
  {
    id: THEATRE_CRITERIA_TYPES.TICKET_PRICE,
    label: "Ticket Price",
    minPlaceholder: "Minimum Price",
    maxPlaceholder: "Maximum Price",
  },
  {
    id: THEATRE_CRITERIA_TYPES.AUDITORIUM_DIMENSIONS,
    label: "Auditorium Dimensions",
    minPlaceholder: "Min",
    maxPlaceholder: "Max",
    accessors: [
      THEATRE_CRITERIA_TYPES.AUDITORIUM_LENGTH,
      THEATRE_CRITERIA_TYPES.AUDITORIUM_WIDTH,
      THEATRE_CRITERIA_TYPES.AUDITORIUM_HEIGHT,
    ],
  },
];

export { THEATRE_CRITERIA_TYPES, THEATRE_CRITERIA_MENU_LIST };
